import { apiConstants } from "../../shared/config";
import work from "./type";
const code = apiConstants.code;
const codeAPI = apiConstants.codeAPI;
const group = work.basePath;

export const type = work.key;
export const panels = {
    other_occupations_home: {
        menu: {
            route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), "")}.${group}.home`,
            text: "Home - Mapa",
            icon: "fas fa-map-marked",
        },
        acl: {
            view: "GIM_23000",
        },
    },
    home_other_occupations: {
        menu: {
            route: `${code}.${group}.home`,
            text: "Gestão - Outras Ocupações",
            icon: "fas fa-building",
        },
        acl: {
            view: "GIM_23000",
        },
    },
    other_occupations_global_type: {
        menu: {
            route: `${code}.other_occupations_type_global`,
            text: "Tipos - Globais",
            icon: "fas fa-tasks",
        },
        acl: {
            view: "GIM_23011",
            detail: "GIM_23012",
            add: "GIM_23013",
            edit: "GIM_23024",
            delete: "GIM_23015",
        },
        url: {
            getList: `/${codeAPI}/gestao/other_occupations/type`,
            getShow: `/${codeAPI}/gestao/other_occupations/type/:id`,
            getCreate: `/${codeAPI}/gestao/other_occupations/type`,
            getUpdate: `/${codeAPI}/gestao/other_occupations/type/:id`,
            getDelete: `/${codeAPI}/gestao/other_occupations/type/:id`,
            getRelationship: `/${codeAPI}/:code/type`,
            getEntities: `/${codeAPI}/gestao/entities`,
        },
    },
    other_occupations_global_status: {
        menu: {
            route: `${code}.other_occupations_status_global`,
            text: "Estados - Globais",
            icon: "fas fa-info-circle",
        },
        acl: {
            view: "GIM_23011",
            detail: "GIM_23012",
            add: "GIM_23013",
            edit: "GIM_23024",
            delete: "GIM_23015",
        },
        url: {
            getList: `/${codeAPI}/gestao/other_occupations/status`,
            getShow: `/${codeAPI}/gestao/other_occupations/status/:id`,
            getCreate: `/${codeAPI}/gestao/other_occupations/status`,
            getUpdate: `/${codeAPI}/gestao/other_occupations/status/:id`,
            getDelete: `/${codeAPI}/gestao/other_occupations/status/:id`,
            getRelationship: `/${codeAPI}/:code/status`,
            getEntities: `/${codeAPI}/gestao/entities`,
        },
    },
};

